import { KeyboardDateTimePicker } from '@material-ui/pickers';
import { Moment } from 'moment';
import { useStyledFieldStyles } from './useStyledFieldStyles';

interface Props {
  value: Moment | null;
  onChange: (value: Moment | null) => void;
  onBlur?: () => void;
  placeholder?: string;
}

/**
 * Selector de fecha y hora (24h) con el estilo de los inputs del sistema.
 * A diferencia de `StyledDatePicker`, trabaja directamente con `Moment`
 * porque los filtros de viajes guardan la fecha-hora como `Moment`.
 */
const StyledDateTimePicker = ({
  value,
  onChange,
  onBlur,
  placeholder
}: Props) => {
  const classes = useStyledFieldStyles();

  return (
    <KeyboardDateTimePicker
      clearable
      ampm={false}
      variant="inline"
      inputVariant="outlined"
      format="DD/MM/YYYY HH:mm"
      placeholder={placeholder ?? 'dd/mm/aaaa hh:mm'}
      value={value}
      onChange={(date) => onChange(date as Moment | null)}
      onBlur={onBlur}
      className={classes.field}
      KeyboardButtonProps={{ size: 'small' }}
    />
  );
};

export default StyledDateTimePicker;
